import React, { useEffect } from 'react';
import Loader from './Loader';
import './LoadingOverlay.css';

function LoadingOverlay({ isLoading, message }) {
  // Prevent body scrolling when loader is active
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="loading-backdrop-overlay" role="alert" aria-busy="true">
      <div className="loading-card-wrapper">
        <Loader size="large" />
        {message && <p className="loading-message-text">{message}</p>}
      </div>
    </div>
  );
}

export default LoadingOverlay;
